import React from 'react';
import registeredComponent from '../../utils/registeredComponent';
import PaymentProfileForm from '../payments/PaymentProfileForm';
import { billingConfigs } from '../../ducks';
import { currentCustomer, duckify, singleDuck } from '../../utils/duckify';
import {BILLING_PAYMENT_METHODS, paymentMethodDisplayName} from '../payments/paymentInputs/PaymentSelector';
import { renderedSnippet } from 'ducks/webSnippets';

const mapDucksToProps = () => ({
  currentCustomer,
  billingConfig: singleDuck(billingConfigs, 'current'),
  autopayRequiredMessage: renderedSnippet('contract_autopay_required')
});

export default registeredComponent('RequireAutopay')(duckify(mapDucksToProps)(({submit_url, billingConfig, autopayRequiredMessage, currentCustomer}) => {
  return <div>
    { autopayRequiredMessage && <div dangerouslySetInnerHTML={{ __html: autopayRequiredMessage.body }} /> }

    <PaymentProfileForm
      afterSubmit={() => {
        window.location.href = submit_url;
      }}
      billingConfig={billingConfig}
      buttonText={(cust, method) => `Save ${paymentMethodDisplayName(currentCustomer, method)} Info and Enable Autopay`}
      paymentMethods={currentCustomer.deposit_payment_methods.filter(method => BILLING_PAYMENT_METHODS.includes(method))}
    />
  </div>
}));
